import { computed, defineComponent, inject, onMounted, Component } from 'vue';

import { PersonalityTestTracker } from '@/classes/tracker'
import { Routes } from "@/enums/routes";
import { IRouter, TRoutes } from "@/interfaces/router.interface";
import { IStore } from "@/interfaces/state.interface";

import Introduction from '@/presentation/pages/introduction/introduction.vue';
import Question from '@/presentation/pages/question/question.vue';
import Form from '@/presentation/pages/form/form.vue';
import Results from '@/presentation/pages/results/results.vue';

export default defineComponent({
	setup: () => {
		const store = inject('store') as IStore;
		const routes: TRoutes = {
			[Routes.HOME]: Introduction as Component,
			[Routes.QUESTION]: Question as Component,
			[Routes.FORM]: Form as Component,
			[Routes.RESULTS]: Results as Component
		};

		const router = computed((): IRouter => {
			return store.getters.router();
		});
		// eslint-disable-next-line @typescript-eslint/naming-convention
		const CurrentComponent = computed((): Component => {
			return routes[router.value.current];
		});

		onMounted((): void => {
			PersonalityTestTracker.fireTracking('impression');
		});

		return { router, CurrentComponent };
	}
});
